import { render, staticRenderFns } from "./caseRegister.vue?vue&type=template&id=72d8ab0e&scoped=true"
import script from "./caseRegister.vue?vue&type=script&lang=js"
export * from "./caseRegister.vue?vue&type=script&lang=js"
import style0 from "./caseRegister.vue?vue&type=style&index=0&id=72d8ab0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8ab0e",
  null
  
)

export default component.exports